import React from "react";
import CustomerBanner from "./CustomerBanner";
import { getCustomer } from "./actions";
import { ContentBuilder, useAuthClaims } from "@redriver/cinnamon";
import { claimExists } from "components/auth/utils";
import { TabbedContainer } from "components/containers";
import CustomerDashboard from "./CustomerOverview";
import CustomerAddresses from "./CustomerAddresses";
import CustomerContacts from "./CustomerContacts";
import CustomerEnquiries from "./CustomerEnquiries";
import CustomerQuotes from "./CustomerQuotes";
import CustomerJobs from "./CustomerJobs";
import CustomerInvoices from "./CustomerInvoices";
import { Targets, Actions } from "constants/Permissions";
import { useTabNavigation } from "modules/helpers";

const CustomerOverview = ({ customerId, tab }) => {
  const { permissions } = useAuthClaims();
  const handleTabChange = useTabNavigation();

  const tabs = [
    {
      key: "overview",
      title: "Overview",
      renderContent: ({ onRefresh }, { customer }) => (
        <CustomerDashboard customer={customer} onRefresh={onRefresh} />
      ),
    },
    {
      key: "addresses",
      title: "Addresses",
      renderContent: ({ onRefresh }, { customer }) => (
        <CustomerAddresses onRefresh={onRefresh} customer={customer} />
      ),
    },
    {
      key: "contacts",
      title: "Contacts",
      renderContent: ({ onRefresh }, { customer }) => (
        <CustomerContacts onRefresh={onRefresh} customer={customer} />
      ),
    },
    {
      key: "enquiries",
      title: "Enquiries",
      renderContent: ({ onRefresh }, { customer }) => (
        <CustomerEnquiries
          customer={{ id: customerId, ...customer }}
          onRefresh={onRefresh}
        />
      ),
      target: Targets.Enquiry,
      action: Actions.View,
    },
    {
      key: "quotes",
      title: "Quotes",
      renderContent: ({ customer }) => (
        <CustomerQuotes customer={{ id: customerId, ...customer }} />
      ),
      target: Targets.Quote,
      action: Actions.View,
    },
    {
      key: "jobs",
      title: "Jobs",
      renderContent: ({ customer }) => (
        <CustomerJobs customer={{ id: customerId, ...customer }} />
      ),
      target: Targets.Job,
      action: Actions.View,
    },
    {
      key: "invoices",
      title: "Invoices",
      renderContent: ({ customer }) => (
        <CustomerInvoices customer={{ id: customerId, ...customer }} />
      ),
      target: Targets.Invoice,
      action: Actions.View,
    },
  ];

  const filteredTabs = tabs.filter(
    (t) =>
      (!t.target && !t.action) || claimExists(permissions, t.target, t.action),
  );

  const defaultTabIndex = tab
    ? Math.max(
        0,
        filteredTabs.findIndex((x) => x.key === tab),
      )
    : 0;

  return (
    <ContentBuilder
      loadAction={getCustomer}
      loadParams={{ customerId }}
      initialData={{ address: {} }}
      renderLoading={false}
      renderContent={(customer, state, events) => (
        <React.Fragment>
          <CustomerBanner
            customer={{ ...customer, id: customerId }}
            onRefresh={events.onRefresh}
            loading={state.loading}
          />
          <TabbedContainer
            customer={{ ...customer, id: customerId }}
            onRefresh={events.onRefresh}
            tabs={filteredTabs}
            initialTabIndex={defaultTabIndex}
            onTabChange={handleTabChange}
          />
        </React.Fragment>
      )}
    />
  );
};

export default CustomerOverview;
